import { HilabsThemeProvider } from '@hilabs-react-ui-components/theme'
import React from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { Provider as ReduxProvider } from 'react-redux'
import { RouterProvider } from 'react-router-dom'
import { PersistGate } from 'redux-persist/lib/integration/react'

import { persistor, store } from './redux/store'
import Router from './routes/routes'

import './assets/Style/global.css'
import './assets/Style/mobileGlobal.css'
import './assets/Style/spacing.css'
import CustomSnackbar from './components/Snackbar'

function App() {
  const router = Router()
  return (
    <HelmetProvider>
      <ReduxProvider store={store}>
        <PersistGate loading="Loading..." persistor={persistor}>
          <HilabsThemeProvider>
            <RouterProvider router={router} />
            <CustomSnackbar />
          </HilabsThemeProvider>
        </PersistGate>
      </ReduxProvider>
    </HelmetProvider>
  )
}

export default App
